import $ from "jquery"; // Import jQuery
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import ReactDataTable from "../../../Common/ReactDataTable";
import Select from "react-select";

const EditProductionWorkOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from URL params
  const { checkRequiredFields } = useRequiredFields();
  const [inputs, setInputs] = useState({
    work_order_date: getCurrentDate(),
    delivery_date: getCurrentDate(),
  });
  const [error, setError] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true); // For initial data loading
  const [shapes, setShapes] = useState([]); // Store shapes from API
  const [company, setCompany] = useState([]); // Store companies from API
  const [product, setProduct] = useState([]);
  const [decorations, setDecorations] = useState([]); // Decoration data
  const [colors, setColors] = useState([
    { id: 1, name: "Blue Glaze" },
    { id: 2, name: "Green Glaze" },
    { id: 3, name: "Red Glaze" },
    { id: 4, name: "White Glaze" },
    { id: 5, name: "Black Glaze" },
    { id: 6, name: "Yellow Glaze" },
    { id: 7, name: "Purple Glaze" },
    { id: 8, name: "Brown Glaze" },
  ]); // Replace API call with dummy data

  function getCurrentDate() {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    fetchInitialData();
    fetchWorkOrderData(); // Fetch the existing work order data
    $("body").addClass("collapse-menu");
    $("body").toggleClass("show-left");
    
    Http.get("/planning-image").then((res) => {
      setDecorations(res.data.map(dec => ({ 
        label: dec.code, 
        value: dec.id, 
        decoration_name: dec.decoration_name
      })));
    });
    
    Http.get("/gless-colour").then((res) => {
      setColors(res.data.map(color => ({ label: color.colour_name, value: color.id })));
    });
  }, [id]);

  const fetchWorkOrderData = async () => {
    setDataLoading(true);
    try {
      const response = await Http.get(`/production-work-order/${id}`);
      const workOrderData = response.data;
      
      // Set the main form inputs
      setInputs({
        receipt_no: workOrderData.receipt_no || "",
        company_id: workOrderData.company_id || "",
        work_order_date: workOrderData.work_order_date || getCurrentDate(),
        delivery_date: workOrderData.delivery_date || getCurrentDate(),
        remarks: workOrderData.remarks || "",
      });

      // Set the items list
      if (workOrderData.items && workOrderData.items.length > 0) {
        setList(workOrderData.items.map(item => ({
          ...item,
          id: item.product_id || item.id, // Ensure we have the product ID
          name: item.product?.name || item.name || "", // Product name
          shape_id: item.shape_id || "",
          decoration_code: item.decoration_code || "",
          decoration_name: item.decoration_name || "",
          color_id: item.color_id || "",
          glaze_id: item.glaze_id || "",
          qty: item.qty || "",
          original_qty: item.qty || 0,
          produced_before: item.produced_before,
          production_work_order_item_id: item.id || "",
        })));
      }
    } catch (error) {
      console.error("Error fetching work order data:", error);
      Swal.fire("Error!", "Failed to load work order data.", "error");
      navigate("/production-work-order");
    } finally {
      setDataLoading(false);
    }
  };

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const resProduct = await Http.get(`/product-list/finished_goods`);
      setProduct(resProduct.data);

      const response = await Http.get("/shape");
      const data = response.data;
      setShapes(data.map(shape => ({ label: shape.name, value: shape.id })));
      
      const redCompany = await Http.get("/companies");
      setCompany(redCompany.data.map(comp => ({ label: comp.name, value: comp.id })));

    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
  
  // console.log(decorations);

  const addMoreList = async (productId) => {
    setItemLoading(true);
    try {
      const response = await Http.get(`/product/${productId}`);
      // Check if product already exists in the list
      // if (!list.find((item) => item.id === response.data.id)) {
        setList((prev) => [...prev, { ...response.data, produced_before: false }]);
      // } else {
        // Swal.fire(
        //   "Warning!",
        //   "This Product is already in the list!",
        //   "warning"
        // );
      // }
    } catch (error) {
      console.error("Error fetching product:", error);
      Swal.fire("Error!", "Failed to add product.", "error");
    } finally {
      setItemLoading(false);
    }
  };

  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedList = list.filter((_, i) => i !== index);
        setList(updatedList);
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const selectHandleChange = async (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    const { value } = selectedOption;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleInputChange = (e, index) => {
    const { name, value, decoration_name } = e.target;
    console.log("--- handleInputChange triggered ---");
    console.log("Current list state BEFORE change:", JSON.parse(JSON.stringify(list))); // Deep copy for inspection

    const inputInfo = [...list];
    const currentItem = inputInfo[index];

    if (name === "qty") {
      console.log("Item Index:", index);
      console.log("Product ID:", currentItem.product_id);
      console.log("currentItem.qty (raw from state):", currentItem.qty); // THIS IS CRUCIAL
      console.log("Type of currentItem.qty:", typeof currentItem.qty); // THIS IS CRUCIAL
      const newQty = parseInt(value);
      const originalQty = parseInt(currentItem.original_qty);

      // --- ADD THESE CONSOLE.LOGS ---
      console.log("Original Qty (parsed for comparison):", originalQty);
      console.log("New Qty (parsed from input):", newQty);
      console.log("Raw input value:", value);

      // For non-produced items, any quantity change is allowed
      currentItem.qty = newQty;
      inputInfo[index] = currentItem;
    } else if (name === "decoration_code") {
      inputInfo[index] = {
        ...currentItem,
        decoration_code: value,
        decoration_name: decoration_name,
      };
    } else {
      currentItem[name] = value;
      inputInfo[index] = currentItem;
    }

    setList(inputInfo);
    console.log("Current list state AFTER setList:", JSON.parse(JSON.stringify(inputInfo))); // Log the new state
    console.log("--- End handleInputChange ---");
  };

  const formSubmit = (e) => {
    e.preventDefault();
    const isValid = checkRequiredFields();
    
    const updatedList = list.map((item) => ({
      ...item,
      product_id: item.id,
      shape_id: item.shape_id || null,
      decoration_code: item?.decoration_code ? item?.decoration_code.toString() : null,
      production_work_order_item_id: item.production_work_order_item_id || null,
      glaze_id: item.glaze_id || null,
      color_id: item.glaze_id || null,
    }));

    const formData = {
      ...inputs,
      items: updatedList
    };

    Http.put(`/production-work-order/${id}`, formData) // Use PUT for update
      .then((res) => {
        navigate("/production-work-order", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  const totalQty = list.reduce((acc, item) => acc + (Number(item.qty) || 0), 0);

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Item" },
    { field: "department_art.name", header: "Item" }
  ];

  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  // Show loading spinner while fetching initial data
  if (dataLoading) {
    return (
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Work Order</h5>
        </div>
        <div className="am-pagebody d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <ProgressSpinner />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Work Order</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-8">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Edit Work Order
            </h6>
            <hr></hr>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Work Order No <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      placeholder="Input Invoice No"
                      data-required
                      readOnly // Usually work order numbers shouldn't be editable
                    />
                  </div>
                  <div className="col-lg">
                    <label>Company</label>{" "}
                    <i className="fa fa-star required"></i>
                    <Select
                      name="company_id"
                      value={company.find(comp => comp.value === inputs.company_id) || null}
                      onChange={(selectedOption) => handleChange({ target: { name: 'company_id', value: selectedOption.value } })}
                      options={company}
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Work Order Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="work_order_date"
                      value={inputs.work_order_date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />
                  </div>

                  <div className="col-lg">
                    <label>
                      Delivery Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="delivery_date"
                      value={inputs.delivery_date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Items in the Work Order{" "}
                        <i className="fa fa-star required"></i>
                      </h5>
                    </div>
                    <div className="card-body p-0" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {error && (
                          <ul className="mb-0 mt-2 list-style-none">
                            {Object.entries(error).map(([field, messages]) => (
                              <li  className="alert alert-danger" role="alert" key={field}>
                                {Array.isArray(messages) ? messages.join(', ') : messages}
                              </li>
                            ))}
                          </ul>
                      )}
                      <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                        <thead style={{ position: 'sticky', top: '0', backgroundColor: '#fff', zIndex: '10' }}>
                          <tr>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              #
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Product
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Shape <i className="fa fa-star required"></i>
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Decoration Code
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Decoration Name
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Glaze Color
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Qty <i className="fa fa-star required"></i>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.length < 1 ? (
                            <tr>
                              <td colSpan={7}>
                                <p
                                  style={{ color: "red" }}
                                  className="text-center mt-3"
                                >
                                  Please Add Few Products For Work Order
                                </p>
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {Array.from(list).map((x, i) => (

                            <tr key={i}>
                              {x.produced_before === false ? (
                                <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeList(i)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>
                               ) : <td></td>} 
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="product"
                                  value={list[i].name}
                                  placeholder="Product"
                                  disabled
                                />
                              </td>
                              <td>
                                <Select
                                  name="shape_id"
                                  value={shapes.find(shape => shape.value === x.shape_id) || null}
                                  onChange={(selectedOption) => handleInputChange({ target: { name: 'shape_id', value: selectedOption.value } }, i)}
                                  options={shapes}
                                  data-required
                                  isDisabled={x.produced_before}
                                />
                              </td>
                              <td>
                                <Select
                                  name="decoration_code"
                                  value={decorations.find(decoration => decoration.value === x.decoration_code) || null}
                                  onChange={(selectedOption) => handleInputChange({ target: { name: 'decoration_code', value: selectedOption.value, decoration_name: selectedOption.decoration_name } }, i)}
                                  options={decorations}
                                  isDisabled={x.produced_before}
                                />
                              </td>
                              <td>
                                <textarea
                                  className="form-control"
                                  name="decoration_name"
                                  value={x.decoration_name || ""}
                                  onChange={(e) => handleInputChange(e, i)}
                                  placeholder="Decoration Name"
                                  rows={3}
                                  disabled={x.produced_before}
                                />
                              </td>
                              <td>
                                <Select
                                  name="glaze_id"
                                  value={colors.find(color => color.value === x.glaze_id) || null}
                                  onChange={(selectedOption) => handleInputChange({ target: { name: 'glaze_id', value: selectedOption.value } }, i)}
                                  options={colors}
                                  isDisabled={x.produced_before}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control"
                                  name="qty"
                                  value={x.qty || ""}
                                  onChange={(e) => handleInputChange(e, i)}
                                  placeholder="Qty"
                                  data-required
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {list.length > 0 && (
                          <tfoot style={{ position: 'sticky', bottom: '0', backgroundColor: '#fff', zIndex: '10' }}>
                            <tr>
                              <td colSpan={6} className="text-right font-weight-bold">
                                Total Qty:
                              </td>
                              <td className="font-weight-bold">
                                {totalQty}
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-save mg-r-10"></i> Update
                    </button>
                  </div>
                  <div className="col-3">
                    <button
                      className="btn btn-secondary btn-block mg-b-10"
                      onClick={() => navigate("/production-work-order")}
                    >
                      <i className="fa fa-arrow-left mg-r-10"></i> Back
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-3"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Available Items
            </h6>
            <hr></hr>
            <ReactDataTable
              cols={cols}
              receiveData={product}
              isLoading={loading}
              actionTemplate={actionTemplate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProductionWorkOrder;
